import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { RANGE_OPTIONS, SITE_OPTIONS } from "../../constants";

interface AnalyticsFiltersProps {
  days: number;
  site: string | null;
  onDaysChange: (days: number) => void;
  onSiteChange: (site: string | null) => void;
}

// Both filters sit in one row above the charts, so changing a range never moves
// the plots down the page.
const AnalyticsFilters: React.FC<AnalyticsFiltersProps> = ({
  days,
  site,
  onDaysChange,
  onSiteChange,
}) => (
  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
    <ToggleButtonGroup
      exclusive
      size="small"
      value={days}
      onChange={(_, value) => value != null && onDaysChange(value)}
      aria-label="Date range"
    >
      {RANGE_OPTIONS.map((option) => (
        <ToggleButton key={option.days} value={option.days}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>

    <ToggleButtonGroup
      exclusive
      size="small"
      // ToggleButtonGroup treats null as "nothing selected", so the both-sites
      // option rides as a sentinel string and is mapped back on the way out.
      value={site ?? "all"}
      onChange={(_, value) =>
        value != null && onSiteChange(value === "all" ? null : value)
      }
      aria-label="Site"
    >
      {SITE_OPTIONS.map((option) => (
        <ToggleButton key={option.label} value={option.value ?? "all"}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  </Box>
);

export default AnalyticsFilters;
